import {appUrl} from '@frontend/AppUrl'
import {useLanguageConfig} from '@frontend/hooks/useLanguageConfig'
import {useRegionConfig} from '@frontend/hooks/useRegionConfig'
import {LocaleService} from '@frontend/services/LocaleService'
import clsx from 'clsx'
import {useMemo} from 'react'
import {LanguageSwitcherDropdown} from 'swayok-react-mdb-ui-kit/components/Localization/LanguageSwitcherDropdown'
import {RegionSwitcherDropdown} from 'swayok-react-mdb-ui-kit/components/Localization/RegionSwitcherDropdown'
import {NavigationService} from 'swayok-react-mdb-ui-kit/services/NavigationService'

// Переключение между языками и регионами приложения.
export function FooterLocaleAndRegionSwitcher() {

    const languageConfig = useLanguageConfig()
    const regionConfig = useRegionConfig()

    const languagesOptions = useMemo(
        () => LocaleService.getLanguagesListAsOptions(),
        []
    )

    const regionsOptions = useMemo(
        () => LocaleService.getRegionsListAsOptions(),
        []
    )

    const hasMultipleLanguages: boolean = languagesOptions.length > 1
    const hasMultipleRegions: boolean = regionsOptions.length > 1

    if (!hasMultipleRegions && !hasMultipleLanguages) {
        // Доступен 1 язык и 1 регион: не нужно показывать переключатели.
        return null
    }

    return (
        <div className="footer-locale-switcher d-block d-lg-inline mt-2 mb-md-1 mt-md-0 my-xxl-0 me-xxl-4 text-center text-md-start">
            {hasMultipleLanguages && (
                <LanguageSwitcherDropdown
                    currentLanguage={languageConfig}
                    options={languagesOptions}
                    url={NavigationService.makeFullUrl(appUrl().index, null, undefined, true)}
                    iconSize={18}
                    className="d-inline-block"
                />
            )}
            {hasMultipleRegions && (
                <RegionSwitcherDropdown
                    currentRegion={regionConfig}
                    options={regionsOptions}
                    url={NavigationService.makeFullUrl(appUrl().index, null, undefined, true)}
                    iconSize={18}
                    className={clsx(
                        'd-inline-block',
                        hasMultipleLanguages ? 'ms-3' : null
                    )}
                />
            )}
        </div>
    )
}
